import React from "react";
import Select from "react-select";
import DocumentSelector from "components/LanguageModelArtifact/DocumentSelector";
import { NumericInput } from "components/Inputs/NumericInput";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { getChatApp } from "containers/ChatGPT/reducer";
import { useSelector } from "types/store";
import { customMapper, selectOnChangeWrapper } from "utils/select";
import styles from "./style.module.css";
import { keysOf } from "utils/collect";
import { Button, ButtonGroup } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
const DEFAULT_SCORE_THRESHOLD = 0.85;
export const RetrieverDocumentSetInput = ({ value, onChange, isDisabled, defaults }) => {
    const linkColor = useSelector((state) => getChatApp(state)?.wizard?.linkColor);
    return (React.createElement("div", { className: styles.settingFlex },
        React.createElement("div", null, "Document to search"),
        React.createElement("div", { style: { width: "300px" } },
            React.createElement(DocumentSelector, { artifactId: value, onChange: (artifact) => (artifact === undefined ? defaults.bm25.artifact_id : onChange(artifact.id)), menuPlacement: "top", forceSelection: true, isDisabled: isDisabled, color: linkColor, allowUpload: false }))));
};
export const BM25RetrieverInput = ({ value, onChange, isDisabled, defaults, wrapperStyle }) => {
    return (React.createElement("div", { className: wrapperStyle ? wrapperStyle : styles.retrieverItemWrapper },
        React.createElement(RetrieverDocumentSetInput, { value: value.artifact_id, onChange: (artifact_id) => onChange({
                ...value,
                artifact_id
            }), isDisabled: isDisabled, defaults: defaults }),
        React.createElement("div", { className: styles.settingFlex },
            React.createElement("div", { className: styles.settingLabel }, "Retrieval K"),
            React.createElement("div", null,
                React.createElement(NumericInput, { value: value.k, onChange: (k) => onChange({
                        ...value,
                        k: k
                    }), isDisabled: isDisabled, inputType: "int", min: 0 })))));
};
export const VectorRetrieverInput = ({ value, onChange, isDisabled, defaults, wrapperStyle }) => {
    return (React.createElement("div", { className: wrapperStyle ? wrapperStyle : styles.retrieverItemWrapper },
        React.createElement(RetrieverDocumentSetInput, { value: value.artifact_id, onChange: (artifact_id) => onChange({
                ...value,
                artifact_id
            }), isDisabled: isDisabled, defaults: defaults }),
        React.createElement("div", { className: styles.settingFlex },
            React.createElement("div", { className: styles.settingLabel }, "Retrieval K"),
            React.createElement("div", null,
                React.createElement(NumericInput, { value: value.k, onChange: (k) => onChange({
                        ...value,
                        k
                    }), isDisabled: isDisabled, inputType: "int", min: 0 }))),
        value.type === "vector_mmr" ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.settingFlex },
                React.createElement("div", { className: styles.settingLabel }, "Fetch K"),
                React.createElement("div", null,
                    React.createElement(NumericInput, { value: value.fetch_k, onChange: (fetch_k) => onChange({
                            ...value,
                            fetch_k
                        }), isDisabled: isDisabled, inputType: "int", min: 0 }))),
            React.createElement("div", { className: styles.settingFlex },
                React.createElement("div", { className: styles.settingLabel }, "Degree of Diversity (0 to 1)"),
                React.createElement("div", null,
                    React.createElement(NumericInput, { value: value.lambda_mult, onChange: (lambda_mult) => onChange({
                            ...value,
                            lambda_mult
                        }), isDisabled: isDisabled, inputType: "float", min: 0, max: 1 }))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.settingFlex },
                React.createElement("div", { className: styles.settingLabel }, "Exclude Results Below Cutoff"),
                React.createElement(LabeledToggle, { style: { display: "block" }, checked: value.score_threshold !== undefined, onChange: () => {
                        onChange({
                            ...value,
                            score_threshold: value.score_threshold !== undefined
                                ? undefined
                                : (defaults.vector_similarity.score_threshold ?? DEFAULT_SCORE_THRESHOLD)
                        });
                    }, disabled: isDisabled, isAibleColors: true })),
            value.score_threshold === undefined ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: styles.settingFlex },
                React.createElement("div", { className: styles.settingLabel }, "Similarity Score Cutoff"),
                React.createElement("div", null,
                    React.createElement(NumericInput, { value: value.score_threshold, onChange: (score_threshold) => onChange({
                            ...value,
                            score_threshold
                        }), isDisabled: isDisabled, inputType: "float", min: 0, max: 1 }))))))));
};
export const MultiQueryRetrieverInput = ({ value, onChange, isDisabled, defaults, wrapperStyle }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: wrapperStyle ? wrapperStyle : styles.retrieverItemWrapper, style: { marginBottom: "5px" } },
            React.createElement("div", { className: styles.settingLabel },
                React.createElement("div", null, "Prompt Template")),
            React.createElement("textarea", { className: styles.settingPrompt, value: value?.prompt_template.template, onChange: (event) => onChange({
                    ...value,
                    prompt_template: {
                        ...value.prompt_template,
                        template: event.target.value
                    }
                }), disabled: isDisabled })),
        React.createElement(RetrieverInputWithType, { value: value.retriever_config, onChange: (retriever_config) => onChange({ ...value, retriever_config }), isDisabled: isDisabled, defaults: defaults })));
};
export const EnsembleRetrieverItemInput = ({ value, onChange, onDelete, isDisabled, defaults }) => {
    return (React.createElement("div", { className: styles.ensembleItemWrapper },
        React.createElement(RetrieverInputWithType, { value: value.retriever_config, onChange: (retriever_config) => onChange({ ...value, retriever_config }), isDisabled: isDisabled, defaults: defaults, wrapperStyle: " " }),
        React.createElement("div", { className: styles.settingFlex },
            React.createElement("div", { className: styles.settingLabel }, "Weight"),
            React.createElement("div", null,
                React.createElement(NumericInput, { value: value.weight, onChange: (weight) => onChange({
                        ...value,
                        weight
                    }), isDisabled: isDisabled, inputType: "float", min: 0, max: 1 }))),
        React.createElement("div", { className: styles.settingFlex },
            React.createElement(Button, { isSmall: true, type: "secondary", style: { marginLeft: "auto" }, disabled: onDelete === undefined, onClick: () => onDelete?.() }, "Delete"))));
};
export const EnsembleRetrieverInput = ({ value, onChange, isDisabled, defaults }) => {
    return (React.createElement("div", null,
        value.items.map((item, i) => (React.createElement(EnsembleRetrieverItemInput, { key: i, value: item, onChange: (update) => {
                const items = value.items.slice();
                items[i] = update;
                onChange({
                    ...value,
                    items
                });
            }, onDelete: value.items.length < 2
                ? undefined
                : () => {
                    const items = value.items.filter((_, j) => i != j);
                    onChange({
                        ...value,
                        items
                    });
                }, isDisabled: isDisabled, defaults: defaults }))),
        React.createElement("div", { className: styles.retrieverTypeWrapper },
            React.createElement("div", { style: { marginRight: "32px" } }, "Add Search Type"),
            React.createElement(ButtonGroup, null,
                React.createElement(OverlayTrigger, { placement: "top", trigger: ["hover"], rootClose: true, overlay: React.createElement(Popover, null,
                        React.createElement("div", { className: styles.retrieverTypeTooltip }, "This is a traditional search method that ranks documents based on how well they match the words in your query. It gives higher scores to documents with terms that are more relevant to the query.")) },
                    React.createElement(Button, { isSmall: true, type: "secondary", onClick: () => {
                            const items = value.items.slice();
                            items.push({
                                retriever_config: defaults.bm25,
                                weight: 1
                            });
                            onChange({
                                ...value,
                                items
                            });
                        } }, "BM25")),
                React.createElement(OverlayTrigger, { placement: "top", trigger: ["hover"], rootClose: true, overlay: React.createElement(Popover, null,
                        React.createElement("div", { className: styles.retrieverTypeTooltip }, "This method finds documents by comparing the meanings of words. It uses mathematical vectors to measure how similar the content of the documents is to your query, focusing on meaning rather than just exact word matches.")) },
                    React.createElement(Button, { isSmall: true, type: "secondary", onClick: () => {
                            const items = value.items.slice();
                            items.push({
                                retriever_config: defaults.vector_similarity,
                                weight: 1
                            });
                            onChange({
                                ...value,
                                items
                            });
                        } }, "Vector Similarity")),
                React.createElement(OverlayTrigger, { placement: "top", trigger: ["hover"], rootClose: true, overlay: React.createElement(Popover, null,
                        React.createElement("div", { className: styles.retrieverTypeTooltip }, "MMR balances finding relevant documents with ensuring diversity. It selects documents that are both closely related to your query and different from each other, avoiding too much overlap.")) },
                    React.createElement(Button, { isSmall: true, type: "secondary", onClick: () => {
                            const items = value.items.slice();
                            items.push({
                                retriever_config: defaults.vector_mmr,
                                weight: 1
                            });
                            onChange({
                                ...value,
                                items
                            });
                        } }, "MMR")),
                React.createElement(OverlayTrigger, { placement: "top", trigger: ["hover"], rootClose: true, overlay: React.createElement(Popover, null,
                        React.createElement("div", { className: styles.retrieverTypeTooltip }, "This approach allows you to use multiple different queries at once. It retrieves documents that match any of the queries, helping to cover more possible ways of asking the same question.")) },
                    React.createElement(Button, { isSmall: true, type: "secondary", onClick: () => {
                            const items = value.items.slice();
                            items.push({
                                retriever_config: defaults.multi_query,
                                weight: 1
                            });
                            onChange({
                                ...value,
                                items
                            });
                        } }, "Multi-Query"))))));
};
export const RetrieverInput = ({ value, onChange, isDisabled, defaults, wrapperStyle }) => {
    switch (value.type) {
        case "bm25":
            return (React.createElement(BM25RetrieverInput, { value: value, onChange: onChange, isDisabled: isDisabled, defaults: defaults, wrapperStyle: wrapperStyle }));
        case "vector_mmr":
        case "vector_similarity":
            return (React.createElement(VectorRetrieverInput, { value: value, onChange: onChange, isDisabled: isDisabled, defaults: defaults, wrapperStyle: wrapperStyle }));
        case "multi_query":
            return (React.createElement(MultiQueryRetrieverInput, { value: value, onChange: onChange, isDisabled: isDisabled, defaults: defaults, wrapperStyle: wrapperStyle }));
        case "ensemble":
            return (React.createElement(EnsembleRetrieverInput, { value: value, onChange: onChange, isDisabled: isDisabled, defaults: defaults, wrapperStyle: wrapperStyle }));
    }
    return React.createElement(React.Fragment, null);
};
const RETRIEVER_TYPE_LABEL_MAP = {
    bm25: "BM25 Text Rank",
    vector_similarity: "Vector Similarity",
    vector_mmr: "Maximal Marginal Relevance",
    multi_query: "Multi Query",
    ensemble: "Ensemble"
};
const RETRIEVER_TYPE_MAPPER = customMapper((t) => RETRIEVER_TYPE_LABEL_MAP[t]);
export const RetrieverInputWithType = ({ value, onChange, isDisabled, defaults, wrapperStyle }) => {
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: "5px" } },
            React.createElement("div", { className: styles.settingFlex },
                React.createElement("div", { style: { width: "225px" } },
                    React.createElement(Select, { options: RETRIEVER_TYPE_MAPPER.mapAll(keysOf(RETRIEVER_TYPE_LABEL_MAP)), value: RETRIEVER_TYPE_MAPPER.map(value?.type), onChange: selectOnChangeWrapper((type) => {
                            if (type === undefined || type === value.type) {
                                return;
                            }
                            let update = defaults[type];
                            if (update.type === "ensemble" && update.items.length === 0) {
                                update = {
                                    ...update,
                                    items: [
                                        {
                                            retriever_config: defaults.vector_similarity,
                                            weight: 1
                                        }
                                    ]
                                };
                            }
                            onChange(update);
                        }), menuPlacement: "top", isDisabled: isDisabled })))),
        React.createElement("div", null,
            React.createElement(RetrieverInput, { value: value, onChange: onChange, isDisabled: isDisabled, defaults: defaults, wrapperStyle: wrapperStyle }))));
};
